import type { Theme } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface DataTableWithGroupingComponentStyles {
  actionsCell: AppSx;
  editButton: AppSx;
  editIcon: AppSx;
  editIconColor: AppSx;
  deleteButton: AppSx;
  deleteIconColor: AppSx;
  deleteIcon: AppSx;
  addChildButton: AppSx;
  addChildIcon: AppSx;
  editIconCombined: AppSx;
  deleteIconCombined: AppSx;
  addChildIconCombined: AppSx;
  groupHeaderRowStyle: { backgroundColor: string; fontWeight: string; fontSize: string };
  toolbar: AppSx;
  toolbarRefreshCell: AppSx;
  groupHeaderConditionalRowStyles: Array<{
    when: (row: { __isGroupHeader?: boolean }) => boolean;
    style: { backgroundColor: string; fontWeight: string; fontSize: string };
  }>;
}

export function buildDataTableWithGroupingComponentStyles(
  _theme: Theme
): DataTableWithGroupingComponentStyles {
  const editIcon = { fontSize: "1.375rem" };
  const editIconColor = { color: "darkblue" };
  const deleteIcon = { fontSize: "1.375rem" };
  const deleteIconColor = { color: "#e74c3c" };

  return {
    actionsCell: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "nowrap",
      gap: 0.25,
      width: "100%",
      maxWidth: "100%",
      overflow: "hidden",
    },
    editButton: { p: 0.75, flexShrink: 0 },
    editIcon,
    editIconColor,
    deleteIcon,
    deleteIconColor,
    editIconCombined: { ...editIcon, ...editIconColor },
    deleteButton: { p: 0.75, flexShrink: 0 },
    deleteIconCombined: { ...deleteIcon, ...deleteIconColor },
    addChildButton: { p: 0.75, flexShrink: 0 },
    addChildIcon: {
      border: "solid 1px gray",
      color: "darkgreen",
      backgroundColor: "lightblue",
    },
    addChildIconCombined: {
      border: "solid 1px gray",
      color: "darkgreen",
      backgroundColor: "lightblue",
      fontSize: "1.375rem",
    },
    groupHeaderRowStyle: {
      backgroundColor: "lightgray",
      fontWeight: "bold",
      fontSize: "16px",
    },
    toolbar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      p: 3,
    },
    toolbarRefreshCell: { color: "text", px: 2 },
    groupHeaderConditionalRowStyles: [
      {
        when: (row) => Boolean(row.__isGroupHeader),
        style: {
          backgroundColor: "lightgray",
          fontWeight: "bold",
          fontSize: "16px",
        },
      },
    ],
  };
}
